import { SectionHeading } from './SectionHeading'

const FEATURES = [
  {
    icon: '⚡',
    title: 'AIのスピードと、エンジニアの品質。',
    description:
      '企画から運用までAIで徹底的に効率化しつつ、設計判断や品質管理は経験豊富なエンジニアが担当。ブラックボックス化を防ぎ、納品後の機能追加や継続的な保守運用まで責任を持って並走します。'
  },
  {
    icon: '🔗',
    title: '複雑な設計こそ、得意領域。',
    description:
      'BtoCやBtoBのマッチングシステムの開発経験が豊富にあり、またサブスクリプションや課金モデルの実装経験など、設計力とセキュリティ性が求められる開発の経験が豊富です。'
  },
  {
    icon: '🖥️',
    title: '新しい技術も、枯れた技術も。',
    description:
      '組み込み機器や外付けデバイスとの連携、スマホネイティブアプリ・Windowsデスクトップアプリなどレガシーな技術の知見も豊富で、既存システムの改修も対応可能です。'
  }
]

export function Features() {
  return (
    <section
      id="features"
      className="section-wrapper relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50/40" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Our Strengths" title="当社の特徴" />

        <p className="w-full  text-brand-navy/60 text-base md:text-lg leading-relaxed mb-10 animate-on-scroll text-center px-20">
          弊社は「乗換案内」で有名なジョルダン株式会社（東証：3710）の１００％子会社です。
          <br />
          金融系のフロント開発、求人募集やオークション等のマッチングシステム、課金決済システムなど、複雑で設計力が求められる開発を得意とするシステム開発会社です。
        </p>

        <div className="grid md:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              className={`animate-on-scroll animate-on-scroll-delay-${(i % 3) + 1} bg-white border border-slate-100 rounded-2xl p-8 shadow-sm hover:shadow-md hover:border-brand-cyan/40 transition-all duration-300 group`}
              style={{ containerType: 'inline-size' }}
            >
              <div className="text-4xl mb-5">{f.icon}</div>
              <h3
                className="font-bold text-brand-navy mb-3 group-hover:text-brand-blue transition-colors whitespace-nowrap"
                style={{ fontSize: 'clamp(1rem, 5.5cqi, 1.5rem)' }}
              >
                {f.title}
              </h3>
              <p className="text-brand-navy/60 text-sm leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
